import React, { Component } from 'react';
import { Typography, Button, TextField, OutlinedInput, InputAdornment, Tooltip, MenuItem, Box } from '@mui/material';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import './../../../Laboratory/Home/home.css';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from "luxon";
import { Trans, withTranslation } from 'react-i18next';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import CircularProgress from '@mui/material/CircularProgress';
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import { hi } from 'date-fns/locale';

class IPRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchkey: "",
            ipRequestData: [],
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            deletePopupOpen: false, 
            selectedItem: null,
        }
    }
    componentDidMount() {
        this.getIPRequest()
    }

    LoaderFunction = (key) => {
        this.setState({
          isLoader: key
        })
      }

    getIPRequest() {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.IP_REQUEST_HOME + "?search_key=" + this.state.searchkey)
                .then(response => {
                    if (response.data.status == "success") {
                        this.setState({
                            ipRequestData: response.data.data
                        }, ()=>{this.LoaderFunction(false)});
                    }
                })
                .catch(e => {
                    if (e?.reponse?.data?.status === 'fail') {
                        this.LoaderFunction(false)
                        this.errorMsgFunc(e.reponse.data.status)
                    } else {
                        this.LoaderFunction(false)
                        this.errorMsgFunc(e.message)
                    }
                });
        }
        catch (e) {
            this.errorMsgFunc(e.message)
        }
    }
    errorMsgFunc = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMsgFunc = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    // Handle Deny button click
    handleDenyClick = (item) => {
        this.setState({
            deletePopupOpen: true,
            selectedItem: item
        });
    }

    // Handle delete confirmation
    handleDeleteConfirm = () => {
        if (this.state.selectedItem) {
            this.denyIPRequest(this.state.selectedItem);
        }
        this.setState({
            deletePopupOpen: false,
            selectedItem: null
        });
    }

    // Handle delete popup close
    handleDeletePopupClose = () => {
        this.setState({
            deletePopupOpen: false,
            selectedItem: null
        });
    }

    // API call to deny IP request
    denyIPRequest = (item) => {
        try {
            let data= {
                id: item.id
            }
            RestAPIService.create(data,Serviceurls.IP_REQUEST_DENY) 
                .then(response => {
                    if (response.data.status === "success") {
                        this.successMsgFunc("IP request denied successfully");
                        this.getIPRequest();
                    }
                })
                .catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        this.errorMsgFunc(e.response.data.message || "Failed to deny IP request");
                    } else {
                        this.errorMsgFunc(e.message || "Failed to deny IP request");
                    }
                });
        }
        catch (e) {
            this.errorMsgFunc(e.message || "Failed to deny IP request");
        }
    }

    // getIPRequestPrint = (patient_id) => {
    //     RestAPIService.getAll(Serviceurls.IP_REQUEST_HOME + `?export_type=pdf&patient_id=${patient_id}`).
    //         then((response) => {
    //             const file = new Blob(
    //                 [response.data],
    //                 { type: 'application/pdf' });
    //             const fileURL = URL.createObjectURL(file);
    //             window.open(fileURL);
    //         }).catch((error) => {
    //             this.setState({
    //                 isErrorMsg: true,
    //                 isErrorMsgText: error.reponse.data.message
    //             }, () => {
    //                 setTimeout(() => {
    //                     this.setState({ isErrorMsg: false })
    //                 }, 2000);
    //             })
    //         })
    // }
    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }
    render() {
        const { t } = this.props
        const { history } = this.props.properties
        return (
            <div  style={this.props.recallKey ? { width: "40vw" } : {width: "34vw"}} >
                <div style={{ display: "flex", margin: "0.5vw", position: "sticky", top: 0, backgroundColor: "white", zIndex: 1000, padding: "0.5vw 0", }}>
                    <label style={{ flex: "0.5" }}><b>{t("In Patient Request")}</b></label>
                    <div style={{ flex: "0.5", display: "flex", justifyContent: "end" }}
                        onClick={() => { this.props.onClickrequestClose(false) }}>
                        <img
                            src={ImagePaths.LabCloseButton.default}
                            style={{ cursor: "pointer", height: "1vw", width: "1vw" }}
                            alt=""
                        />
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'end', position: "sticky", top: "3vw", backgroundColor: "white", zIndex: 1000, paddingBottom: '0.5vw', padding: "0.5vw 0" }}>
                    <OutlinedInput
                        placeholder="Search Patients..."
                        onChange={(e) => {
                            this.setState({
                                searchkey: e.target.value
                            }, () => {
                                this.getIPRequest()
                            })
                        }}
                        value={this.state.searchkey}
                        size="small"
                        sx={{ width: "13vw", marginRight: "0vw" }}
                        endAdornment={
                            <InputAdornment position="end">
                                <i class="fas fa-search"></i>
                            </InputAdornment>
                        }
                        inputProps={{ emed_tid: "IPreq_search_bill"}}
                    />
                </div>

                <div style={{
                    height: "25vw",
                    width:  this.props.recallKey ? '40vw' : '35vw',
                    overflow: this .props.recallKey ? "auto" : 'hidden',
                }}>
                {this.state.ipRequestData && this.state.ipRequestData?.length > 0 ?
                    <div className='eMed_Pres_DataView' style={this.props.recallKey ? {width: '39vw', overflow:'visible' }: {width: '33.5vw'}}>
                        {this.state.ipRequestData?.map((item, index) => {
                            var count = item?.line_items?.length
                            return (
                                <Box emed_tid="IPreq_toBill_item" 
                                    className="Lab_Home_Saved_Bill" style={{ cursor: 'pointer' }}>
                                    <div style={{ flex: 0.1 }}>{index + 1}</div>
                                    <div style={{ flex: 0.22 }}><img src={ImagePaths.Male.default} alt='Avatar' /></div>
                                    <div style={{  flex: this.props.recallKey ? 0.70 : 0.60 }}> 
                                        {(item?.patient_name?.length || 0) > 15 ?
                                            <Tooltip title={item?.patient_name} placement='top'>
                                                <Typography className='savedBillText'>{item?.patient_name ? item?.patient_name?.slice(0, 15) + '...' : '-'}</Typography>
                                            </Tooltip> : <Typography className='savedBillText'>{item?.patient_name ? item?.patient_name : '-'}</Typography>}
                                        <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{`${item?.patient_mobile ? item?.patient_mobile : '-'} | ${item?.patient_account_number ? item?.patient_account_number : '-'}`}</Typography>
                                        {(item?.ip_number?.length || 0) > 15 ?
                                            <Tooltip title={item?.ip_number} placement='top'>
                                                <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{`${'IP No: ' + (item?.ip_number ? '...' + item.ip_number?.slice(15) : '-')}`}</Typography>
                                            </Tooltip> : <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{`${'IP No: ' + (item?.ip_number ? item?.ip_number : '-')}`}</Typography>}
                                    </div>
                                    <div style={{ flex: this.props.recallKey ? 0.30 : 0.20 }}>
                                        <Typography className='savedBillText' style={{width: '6vw'}}>{item?.created_date ? item?.created_date : '-'}</Typography>
                                        <Typography sx={{ fontSize: "0.8vw", color: '#C9CACC' }}>{`${'Drug Count: ' + (count ? count : '0') }` }</Typography>
                                    </div>

                                    <div style={{ flex: 0.40, display: 'flex', justifyContent: 'center' }}>
                                        <Button size="small" variant="contained" color="primary" sx={{ textTransform: 'capitalize' }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.props.properties.history.push({ pathname: "/PharmacyBilling", state: { isFromIpRequest: true, billDetails: item } })
                                                this.props.onClickrequestClose(false)
                                            }}
                                        > Proceed
                                        </Button>
                                    </div>
                                    {this.props.recallKey ? <div style={{ flex: 0.40, display: 'flex', justifyContent: 'center' }}>
                                        <Button size="small" variant="contained" color="error" sx={{ textTransform: 'capitalize' }}
                                            onClick={this.props.recallKey ? (e) => {
                                                e.stopPropagation();
                                                this.handleDenyClick(item);
                                            } :
                                                () => {
                                                    this.props.properties.history.push({ pathname: "/PharmacyBilling", state: { isFromIpRequest: true, billDetails: item } })
                                                    this.props.onClickrequestClose(false)
                                                }
                                            }
                                        >
                                            Deny
                                        </Button>
                                    </div> : null}
                                </Box>
                            )
                        })}

                    </div> :
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                    }}>
                    {this.state.isLoader ? <div style={{display: 'flex', alignItems:'center', justifyContent:'center'}} className='eMed_App_DataView'><CircularProgress/></div>:<div><Typography id='eMed_Pres_pop_NORec'>{t("No records found")}</Typography></div>}
                    </div>}
                </div>
                 {this.state.deletePopupOpen && (
                    <DeletePopup 
                        DeletTitle={("Are you sure you want to deny the IP request.")} 
                        DeleteNotify={t("This action cannot be undone")}
                        deleteAlertPopupClose={this.handleDeletePopupClose}
                        removeData={this.handleDeleteConfirm}
                    />
                )}
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </div>
        );
    }
}
export default withTranslation()(IPRequest)